(function () {
  // V_TIME_COL_02 — click-and-drag horizontal scroll for the worn-by cards list.
  function initDragScroll() {
    const lists = document.querySelectorAll(".c-worn-by-col-list");
    if (!lists.length) return;

    lists.forEach((list) => {
      let isDown = false;
      let hasMoved = false;
      let startX = 0;
      let startScrollLeft = 0;

      list.addEventListener("mousedown", (e) => {
        // Ignore right-clicks / middle-clicks
        if (e.button !== 0) return;
        isDown = true;
        hasMoved = false;
        startX = e.pageX;
        startScrollLeft = list.scrollLeft;
        list.classList.add("c-is-dragging");
      });

      list.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        const delta = e.pageX - startX;
        if (Math.abs(delta) > 3) hasMoved = true;
        e.preventDefault();
        list.scrollLeft = startScrollLeft - delta;
      });

      const release = () => {
        if (!isDown) return;
        isDown = false;
        list.classList.remove("c-is-dragging");
      };

      list.addEventListener("mouseup", release);
      list.addEventListener("mouseleave", release);

      // Suppress the click that fires after a drag, so dragging over a card
      // doesn't accidentally activate any click handlers on it.
      list.addEventListener(
        "click",
        (e) => {
          if (hasMoved) {
            e.preventDefault();
            e.stopPropagation();
            hasMoved = false;
          }
        },
        true
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDragScroll);
  } else {
    initDragScroll();
  }
})();

(function () {
  // V_TIME_CART_04 — Timeloop+ Subscription Upsell, Cart Hidden vs Shown (Var A).
  //
  // Control (no change): the UpCart drawer footer shows the "VIP Checkout+" subscription upsell
  // block (.timeloop-vip-drawer-container) with its benefits + "$9.99 every month", and the theme's
  // own scripts relabel the secondary checkout button to "Checkout without benefits".
  //
  // Var A: hide that upsell block entirely, relabel the remaining button to a plain "Checkout", and
  // make sure the Timeloop+ subscription variant is never in the cart. The body gets the
  // `c-V_TIME_CART_04-test` class from c-intelligems-tests.js. All values (label, variant id) come
  // from the c-v-time-cart-04 snippet's data-* attributes — JS only toggles, no static values here.
  //
  // The theme's interval forces `display:block !important` inline on the upsell block every 500ms, so
  // CSS alone can't hide it — we remove the node instead (the theme's querySelector then no-ops). The
  // theme's click handler on the checkout button (which strips the VIP variant before /checkout) lives
  // on the button element, so relabeling via innerHTML keeps it intact.
  var TEST_CLASS = "c-V_TIME_CART_04-test";
  var FOOTER_SELECTOR = ".upcart-footer, .styles_Footer__";
  var UPSELL_SELECTOR = ".timeloop-vip-drawer-container";
  var CHECKOUT_BTN_SELECTOR = ".upcart-checkout-button";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function readConfig() {
    var el = document.querySelector(".c-v-time-cart-04-config");
    if (!el) return null;
    return {
      checkoutLabel: el.getAttribute("data-checkout-label") || "Checkout",
      vipVariantId: parseInt(el.getAttribute("data-vip-variant-id"), 10),
    };
  }

  // The UpCart drawer can render in the light DOM or inside #upCart's shadow root, so look in both.
  function getRoots() {
    var roots = [document];
    var host = document.querySelector("#upCart");
    if (host && host.shadowRoot) roots.push(host.shadowRoot);
    return roots;
  }

  // Replace the button label while preserving its lock icon. The flicker came from two scripts
  // fighting over every freshly re-rendered button: the theme's loop sets "Checkout without benefits"
  // while ours sets "Checkout". The theme guards its relabel with `dataset.vipProcessed`, so we set
  // that flag here first — the theme then skips this button entirely and never flips the text. We
  // mark it even when the text is already correct, so a just-rendered "Checkout" button is claimed
  // before the theme's next tick can touch it.
  function relabelCheckout(btn, label) {
    if (!btn) return;
    btn.dataset.vipProcessed = "true";
    if (btn.textContent.trim() === label) return;
    var icon = btn.querySelector(".upcartLockIcon, svg, img");
    btn.innerHTML = "";
    if (icon) btn.appendChild(icon);
    btn.appendChild(document.createTextNode(icon ? " " + label : label));
  }

  function applyVarA(cfg) {
    getRoots().forEach(function (root) {
      var footer = root.querySelector(FOOTER_SELECTOR);
      if (!footer) return;

      var upsell = footer.querySelector(UPSELL_SELECTOR);
      if (upsell) upsell.remove();

      relabelCheckout(footer.querySelector(CHECKOUT_BTN_SELECTOR), cfg.checkoutLabel);
    });
  }

  // Belt-and-suspenders: if a shopper landed in Var A with the subscription already in their cart
  // (e.g. switched variants mid-session), strip it so it is never shown or charged. Runs once.
  var cartCleaned = false;
  function removeVipFromCart(cfg) {
    if (cartCleaned || !cfg.vipVariantId) return;
    cartCleaned = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var vipItem = cart.items.find(function (item) {
          return item.variant_id === cfg.vipVariantId;
        });
        if (!vipItem) return;
        return fetch(root + "cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: vipItem.key, quantity: 0 }),
        });
      })
      .catch(function (err) {
        console.error("V_TIME_CART_04 cart cleanup failed:", err);
      });
  }

  var started = false;
  function start() {
    if (started) return;
    if (!document.body.classList.contains(TEST_CLASS)) return;
    var cfg = readConfig();
    if (!cfg) return;
    started = true;

    removeVipFromCart(cfg);

    // The drawer is re-rendered by UpCart on open/update, and the theme keeps re-forcing the upsell
    // visible, so re-apply on an interval (matching the theme's own cadence).
    applyVarA(cfg);
    setInterval(function () {
      applyVarA(cfg);
    }, 300);

    // Re-apply the instant UpCart re-renders the drawer, not just on the next interval tick. The
    // observer callback (coalesced into one rAF per frame) runs before paint, so the fresh button is
    // claimed/relabelled before the theme can flip it — making the text uniform with no visible flash.
    if ("MutationObserver" in window) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          applyVarA(cfg);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  ready(start);
  window.addEventListener("ig:ready", function () {
    ready(start);
  });
})();

(function () {
  // V_TIME_CART_17 — Cart USP Trust Strip (Var A).
  //
  // Control (no change): the UpCart drawer shows its normal internal upsell block with nothing beneath it.
  //
  // Var A: insert a trust-USP strip (Easy Returns / 50,000+ orders shipped! / Secure Checkout) directly
  // BELOW the ".upcart-internal-upsell" block. Body gets `c-V_TIME_CART_17-test` from c-intelligems-tests.js
  // (Var A only). All copy + icons come from the c-v-time-cart-17 <template> (rendered by the snippet from
  // theme settings) — JS only clones the template and inserts it, so no static values live here.
  //
  // UpCart re-renders the drawer on open/update, so we re-insert on an interval + MutationObserver.
  // injectStrip() no-ops when our strip is already the upsell's next sibling, so re-running it is idempotent.
  var TEST_CLASS = "c-V_TIME_CART_17-test";
  var UPSELL_SELECTOR = ".upcart-internal-upsell";
  var STRIP_CLASS = "c-vtc17-strip";
  var TEMPLATE_ID = "c-vtc17-template";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  // The UpCart drawer can render in the light DOM or inside #upCart's shadow root, so look in both.
  function getRoots() {
    var roots = [document];
    var host = document.querySelector("#upCart");
    if (host && host.shadowRoot) roots.push(host.shadowRoot);
    return roots;
  }

  // Clone the strip markup from the Liquid <template> (values already filled in by theme settings).
  function buildStrip() {
    var tpl = document.getElementById(TEMPLATE_ID);
    if (!tpl || !("content" in tpl)) return null;
    return tpl.content.cloneNode(true);
  }

  function injectStrip() {
    getRoots().forEach(function (root) {
      var upsells = root.querySelectorAll(UPSELL_SELECTOR);
      Array.prototype.forEach.call(upsells, function (upsell) {
        var next = upsell.nextElementSibling;
        if (next && next.classList && next.classList.contains(STRIP_CLASS)) return; // already inserted
        var frag = buildStrip();
        if (!frag || !upsell.parentNode) return;
        upsell.parentNode.insertBefore(frag, upsell.nextSibling);
      });
    });
  }

  var started = false;
  function start() {
    if (started) return;
    if (!document.body.classList.contains(TEST_CLASS)) return;
    if (!document.getElementById(TEMPLATE_ID)) return;
    started = true;

    injectStrip();
    setInterval(injectStrip, 300);

    // Re-insert the instant UpCart re-renders the drawer, not just on the next interval tick.
    if ("MutationObserver" in window) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          injectStrip();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  ready(start);
  window.addEventListener("ig:ready", function () {
    ready(start);
  });
})();
